import { assetUrl } from './landingHelpers';
import { integrationBadges } from './landingContent';
import { useWaitlistModal } from '../waitlist/WaitlistModal';

const browserDots = ['#FF2D46', '#FF9500', '#63DE77'];

const ScreenshotFrame = () => (
  <div className="bl-screenshot-frame">
    <div className="bl-screenshot-bar">
      {browserDots.map((color) => (
        <span className="bl-screenshot-dot" style={{ background: color }} key={color} />
      ))}
      <span className="bl-screenshot-url">app.bodylytix.ai - Body Journal</span>
    </div>
    <div className="bl-screenshot-img-wrap">
      <img
        className="bl-screenshot-img"
        src={assetUrl('/assets/img/landing/body-journal.png')}
        alt="BodyLytiX Body Journal"
      />
      <div className="bl-screenshot-fade" aria-hidden="true" />
    </div>
  </div>
);

const Integrations = () => (
  <div className="bl-integrations" aria-label="Supported integrations">
    <span className="bl-integrations__label">Connects with</span>
    {integrationBadges.map((badge) => (
      <div className="bl-integration-badge" key={badge.label}>
        <span className="bl-integration-dot" style={{ background: badge.color }} />
        {badge.label}
        {badge.note ? <small>{badge.note}</small> : null}
      </div>
    ))}
  </div>
);

const LandingHero = () => {
  const { openWaitlistModal } = useWaitlistModal();

  return (
    <>
      <section className="bl-hero">
        <div className="bl-shell bl-hero__grid">
          <div className="bl-hero__content">
            <div className="bl-pill"><span className="bl-pill-dot" /> Now in early access - join the first users</div>
            <h1>
              Your body generates<br />
              data every day.<br />
              <em>BodyLytiX</em> tells you<br />
              what it means.
            </h1>
            <p className="bl-hero__lead">
              Connect your Garmin and Apple Health data to an AI coach that gives you real, personalised insights - not generic advice. One place for sleep, training, recovery and wellness.
            </p>
            <div className="bl-hero__actions">
              <button className="bl-button bl-button--primary" type="button" onClick={openWaitlistModal}>
                Apply to Wish List <i className="fas fa-arrow-right" aria-hidden="true" />
              </button>
            </div>
          </div>

          <div className="bl-hero__visual" aria-label="BodyLytiX product preview">
            <div className="bl-float-badge">
              <span>Recovery</span>
              <strong>68%</strong>
              <small>HRV - 42ms</small>
            </div>
            <ScreenshotFrame />
          </div>
        </div>
      </section>
      <Integrations />
    </>
  );
};

export default LandingHero;
